import {
  getEligibleMedProducts,
  getDefaultEligibilityOptions,
} from "src/utils/medEligibility";
import { getMedRecommendedPlan } from "src/utils/calculateGoals";
import { setRecommendedPlanById } from "src/utils/redux/slices/recommendedPlan";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import saveToBraze from "src/utils/brazeUploader";
import getStore from "src/utils/redux/store";
import { saveRecommendedPlanToCRM } from "./saveRecommendedPlanToCRM";

export const updateRecommendedPlanInCRM = async () => {
  const store = getStore();
  const { recommendedPlan: previousPlan, userData } = store.getState();
  const surveyAnswers = getSurveyAnswers();

  // Disable PD check only if PD questions haven't been completed yet
  const shouldDisablePDCheck =
    !userData?.completedPDQuestions && !surveyAnswers?.pdNauseaImpact;

  const currentEligibleProducts = getEligibleMedProducts({
    ...getDefaultEligibilityOptions(),
    ...(shouldDisablePDCheck && { disabledNamedChecks: ["isQualifiedForPD"] }),
  });

  const newRecommendedPlan = await getMedRecommendedPlan(
    currentEligibleProducts
  );

  if (previousPlan?.noom_plan_id === newRecommendedPlan?.noom_plan_id) {
    return;
  }

  if (newRecommendedPlan?.noom_plan_id) {
    await store.dispatch(
      setRecommendedPlanById(newRecommendedPlan.noom_plan_id, {
        overwriteReset: true,
        overwriteForced: true,
      })
    );
  }

  await saveToBraze({
    user: {
      eligible_med_products: currentEligibleProducts,
    },
  });
  await saveRecommendedPlanToCRM();
};
